import React from 'react'
import flatMap from '@/utils/flatMap'
import * as UI from '@/components/UI'
import {
  Section,
  Grid,
  GalleryCell,
  TestimonialsCell,
} from './TemplateGalleryTestimonials.css'

const TemplateGalleryTestimonials = ({ content, color = 'blue', inverted }) => {
  const testimonials =
    flatMap(content?.testimonials, x => x?.testimonial?.document)?.map(
      x => x?.data,
    ) || []

  return (
    <Section>
      <UI.Container>
        <Grid inverted={inverted}>
          <GalleryCell inverted={inverted}>
            <UI.Gallery color={color} gallery={content.gallery} />
          </GalleryCell>
          <TestimonialsCell inverted={inverted}>
            <UI.TestimonialGroup
              color={color}
              testimonials={testimonials}
              inverted={inverted}
            />
          </TestimonialsCell>
        </Grid>
      </UI.Container>
    </Section>
  )
}

export default TemplateGalleryTestimonials
